import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";

const Container = styled.div<{ active?: boolean }>(({ active, theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  padding: "0.7rem",
  border: active ? `1px solid ${theme.color.black}` : "none",
  cursor: "pointer",
}));

const Ball = styled.div<{ color: string }>(({ color, theme }) => ({
  borderRadius: "50%",
  width: "1.2rem",
  height: "1.2rem",
  backgroundColor: color,
  transition: "background-color 0.3s ease",
  border: `1px solid ${theme.color.light_gray}`,
}));

type Props = {
  color: string;
  colorName?: string;
  active?: boolean;
  onClick?: () => void;
};
const ColorBall = ({ color, colorName, active, onClick }: Props) => {
  return (
    <Container onClick={onClick} active={active}>
      <Ball color={color} />
      <span>{colorName}</span>
    </Container>
  );
};

export default ColorBall;
